export const NAVIGATE_TO_CD = 'CD';
export const NAVIGATE_TO_BAA = 'BAA';
export const NAVIGATE_TO_SOURCE = 'source';
export const NAVIGATE_TO_EXIT = 'NAVIGATE_TO_EXIT';
export const SCREEN_SHOT_MIME_TYPE = 'image/jpeg';
export const SCREEN_SHOT_QUALITY = 0.5;
export const API_STRING_FIELD_MAX_LENGTH = 100000;
export const BUSINESS_TYPE = 'business_type';
export const CASE_ID = 'case_id';
export const CASE_SUBTYPE = 'caseType';
export const BANK_ID = 'bank_id';
export const BRAND_ID = 'brand_id';
export const SHOW_PAGE_TYPE = 'show';
export const DATA_FROM_BUSINESS_ACCOUNT = 'business_account_info';
export const ROUTE_ABOUT_YOUR_BUSINESS = '/aboutBusiness';
export const ROUTE_REVIEW_PAGE = '/businessDetailsAll';
export const SORT_FIELD1 = 'sortField1';
export const SORT_FIELD2 = 'sortField2';
export const SORT_FIELD3 = 'sortField3';
export const DATE_FIELD = 'dateField';
export const MONTH_FIELD = 'monthField';
export const YEAR_FIELD = 'yearField';
export const BUSINESS_UUID = 'business_uuid';
export const POST_CODE_LIST = 'postCodeAddressList';
export const ADD_MANUALLY_SUFFIX = 'ManuallyClickedValue';
export const DEFAULT_EMAIL_ID = 'example@example.com';
export const ROUTE_TAX_FINANCE = '/finances';
export const ROUTE_BUSINESS_FINANCE = '/businessFinance';
export const ROUTE_BUSINESS_CONCTACT_DETAILS = '/businessContactDetails';
export const ROUTE_GDPR = '/gdpr';
export const ROUTE_TECHNICAL_ERROR_PAGE = '/technicalError';
export const CASE_DATA_KEY = 'caseData';
export const PERSONAL_ADDRESS_TYPE = 'personal';
export const REGISTER_ADDRESS_TYPE = 'register';
export const TRADING_ADDRESS_TYPE = 'trading';
export const MAILING_ADDRESS_TYPE = 'mailing';
export const DIFFERENT_ADDRESS_TYPE = 'different';
export const NAVIGATION_BACK = 'back';
export const KEY_YES = 'yes';
export const KEY_NO = 'no';
export const CSS_LOADING_DELAY = 500;
export const BUSINESS_DETAILS = 'business-details';
export const BUSINESS_CURRENT_ACCOUNT = 'Business Current Account';

export const ANALYTICS_ERROR = {
  FETCH_CASE_FAILED: 'Failed to load case details.',
  FETCH_CONFIG_FAILED: 'Failed to load config.',
  FETCH_CUSTOMERBYID_FAILED: 'Failed to load customer by id.'
};

export const CASE_TYPE_NTB = 'ntb';
export const REDIRECT_URI = 'redirect_uri';
export const NAVIAGETION_BACK_KEY = 'back';
export const EXPAND_KEY = 'expand';
export const ACCESS_TOKEN = 'access_token';
export const SOLE_TRADER = 'sole trader';
export const LIMITED_COMPANY_ONE_DIRECTOR = 'Limited company';
export const PRIMARY = 'primary';
export const SECONDARY = 'secondary';
export const VM_BRAND = 'VM';
export const CB_BRAND = 'CB';

export const MULTIPLE_ADDRESS_TRADING = 'mutipleAddressTrading';
export const MULTIPLE_ADDRESS_MAILING = 'mutipleAddressMailing';
export const REGISTER_ADDRESS_SELECTOR = 'registerAddressSelector';
export const TYPE_OF_LICENSE = 'typeOfLicense';
